export * as passengersCounterModel from './model';
export type { PassengersState, PassengerEntity } from './types';
